import MDSpinner from "react-md-spinner";
import Switch from "../../../Components/Switch";
import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const ToggleShowPauseButton = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);
  const [fetchOutstanding, setFetchOutstanding] = useState(false);

  const toggleShowPauseButton = async () => {
    let tempUserData = structuredClone(userData);
    tempUserData.PauseButton = !tempUserData.PauseButton;
    let body = JSON.stringify({
      pauseButton: tempUserData.PauseButton,
    });
    setUserData(tempUserData);
    setFetchOutstanding(true);
    await fetch(`${route}/togglepausebutton.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: body,
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error("Error");
        }
      })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
        tempUserData.PauseButton = !tempUserData.PauseButton;
        setUserData(tempUserData);
      })
      .finally(() => {
        setFetchOutstanding(false);
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Show Pause Button</h3>
      <p className="accountSettingsToggleDescription">
        The real exam does not allow you to pause some audio sections. During
        your practice, you may want to always be able to pause audio. You can
        toggle that here.
      </p>
      <Switch
        value={userData.PauseButton}
        onClick={() => toggleShowPauseButton()}
        customClass="accountSettingsToggle"
      />
      {fetchOutstanding && (
        <div className="accountSettingsCardLoaderOverlay">
          <MDSpinner size={35} singleColor={"#fff"} />
        </div>
      )}
    </div>
  );
};

export default ToggleShowPauseButton;
